export default "__VITE_ASSET__28656fbd__"